// extracted by mini-css-extract-plugin
export default {"title":"anpPi","content":"Hba6_","skills-selection":"VSQrf","quiz-settings":"XFE5K","button":"LyC4H"};